import { getCurrentInstance } from "@vue/composition-api";

/**
 * setup() 内でのみ使用可能
 * https://v3.vuejs.org/api/composition-api.html#getcurrentinstance
 */
export const useComponentInstance = () => {
  const instance = getCurrentInstance();

  if (!instance) {
    throw new Error(`Should be used in setup().`);
  }

  return instance.proxy;
};
